import React, {Component} from 'react'
import '../App'
import 'dotenv'
import {postDynamo, getContactIdInfo} from '../apis/api.js'
// import {getWaitTime} from '../apis/api.js'
import ReactPhoneInput from 'react-phone-input-2'
import ProgressRing from '@hig/progress-ring'
import TextArea from '@hig/text-area'
import TextField from '@hig/text-field'
import Button from '@hig/button'
import Flyout, { anchorPoints } from '@hig/flyout'
import 'react-phone-input-2/dist/style.css'
import '@hig/flyout/build/index.css'
import '@hig/text-area/build/index.css'
import '@hig/text-field/build/index.css'
import '@hig/dropdown/build/index.css'
import '@hig/button/build/index.css'
import './userinfo.css'
import './helphub_template.css'

class Userinfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            question: '',
            estWaitTime: '',
            isLoading: false,
            Fname: this.props.variablesFromLogin.firstName,
            Lname: this.props.variablesFromLogin.lastName,
            fullname: this.props.variablesFromLogin.firstName + ' ' +this.props.variablesFromLogin.lastName,
            email: this.props.variablesFromLogin.email,
            telephone: this.props.variablesFromLogin.phone,
            category: 'Tech Support',
            skillid: '',
            showPopup: true,
            phoneValid: true,
            validateHandler: true
        };
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }
    // call estimated wait time api function for a given skill id
    estimatedWait(){
        let skillid = process.env.REACT_APP_SKILL_ID;
        //Once Promise is resolved set the state
        // Promise.resolve(getWaitTime(skillid))
        // .then((data) => {
        //     // If there are errors when calling API display error message
        //     if ( data == null || data.hasOwnProperty("errorMessage")) {
        //         this.setState({
        //             estWaitTime: null,
        //             isLoading: false
        //         })
        //     }
        //     else {
        //         this.setState({
        //             estWaitTime: data['wait_time'] + " minutes ",
        //             isLoading: false
        //         })
        //     }
        // })
        return this.state.estWaitTime;
    }
    // function to set state and pass the values to App screen
    passFunc(value){
        this.setState({
            skillid: value
        },
        function(){
        //Pass variables state and popup status from home screen to App container
        this.props.popupvariablesCallback(this.state);
        this.props.closePopup(this.state.showPopup);
        })

    }
    // on click call the API
    onSubmit(){
        this.setState({ isLoading: true });
        //API to submit variables to dynamo db
        const phone = this.state.telephone
        const fullname = this.state.fullname
        const email = this.state.email
        const question = this.state.question
        const category = 'Tech Support'
        const product = 'Helphub'
        const catLang = category + '-' + 'English'
        // Resolve fetched promise
        Promise.resolve(
            postDynamo(fullname, email, phone, category, question, product, catLang)
        ).then((data) => {
            const skillId = (data == null || data.hasOwnProperty("errorMessage")) ? 'NoSkillId' : data['Skillid'];
            this.setState({ skillid: skillId }, () => {
                this.props.popupvariablesCallback(this.state);
            });
            // Directly call queuecallback, skipping EWT modal
            return Promise.resolve(getContactIdInfo(email, phone, question, skillId, fullname));
        }).then((data) => {
            const contactId = (data == null || data.hasOwnProperty("errorMessage")) ? 'noContactId' : data['contactId'];
            this.setState({ isLoading: false }, () => {
                this.props.contactIdCallback(contactId);
                this.props.skipToStatus(this.state.showPopup);
            });
        });
    }
    //validate phone number
    validateHandler() {
        let phone = this.state.phoneValid;
        //match regex to check if the phone number is valid with hyphens and different country standards
        phone = this.state.telephone.match(/^(\(?\+?[ ()0-9-]*^.{8,}\d{1,10}$)/)
        if(phone){
            this.setState({
                validateHandler: true
            })
        }
        else{
            this.setState({
                validateHandler: false
            })
        }
    }
    //call estimated wait time on loading
    componentDidMount() {
       // this.estimatedWait();
    }
    // Change value of the variables with input
    onChange({ target }) {
        this.setState({
            [target.name]: target.value

        });
    }
    //unmount component
    componentWillUnmount(){
        this.setState({
            estWaitTime: null,
            isLoading: false
        })
    }
    render() {
        let data;
        if(this.state.isLoading) {
            data = <div><ProgressRing size="s"/></div>
        }
        return (
            <body>
                <div className="dashboard_wrapper">
                    <header >
                        <h1 className="popup-title">Request a Call</h1>
                    </header>
                    <div className="popup_inner">
                        {/* Call result of the data once promise is fetched*/}
                        {data}
                        <TextField
                            placeholder='First Name'
                            type='text'
                            value={this.state.Fname}
                            disabled
                        />
                        <TextField
                            placeholder='Last Name'
                            type='text'
                            value={this.state.Lname}
                            disabled
                        />
                        <TextField
                            placeholder='Email'
                            type='email'
                            value={this.state.email}
                            disabled
                        /><br></br>
                        <Flyout
                            anchorPoint={anchorPoints.TOP_CENTER}
                            content={<p>Specify your desired callback number</p>}
                            maxHeight={35}
                            openOnHover
                        >
                        <ReactPhoneInput
                            inputStyle={{
                                width: '200px',
                                height: '30px',
                                fontSize: 'inherit',
                                paddingLeft: '1px',
                                borderLeft: 'transparent',
                                borderRight: 'transparent',
                                borderTop: 'transparent',
                                borderRadius: '0px',
                                backgroundColor: 'transparent',
                                zIndex: 1
                            }}
                            buttonStyle={{
                                backgroundColor: 'transparent',
                                border: 'transparent',
                                top:0,
                                bottom:0,
                                left:0,
                                right:0,
                                margin: '-5px auto auto -50px',
                                fontSize: 'inherit',
                                position: 'sticky'
                            }}
                            dropdownStyle={{
                                width: '300px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                                fontFamily: 'inherit',
                                fontWeight: 300,
                                position: 'relative'
                            }}
                            name='telephone'
                            placeholder='Enter your Phone number here....'
                            type='tel'
                            enableLongNumbers={true}
                            onChange={ telephone => this.setState({ telephone }, function(){ this.validateHandler()}) }
                            value={this.state.telephone}
                        />
                        </Flyout><br></br><br></br>
                        <TextArea
                            name="question"
                            label="Question (Max 512 characters...)"
                            placeholder="Enter your question here..."
                            value={this.state.question}
                            maxLength='512'
                            onChange={this.onChange}
                            required={false}
                        />
                        {this.state.validateHandler ?
                            <Button
                                size="large"
                                title="Request Call"
                                onClick={() => this.onSubmit()}
                            /> :
                            <Button
                                size="large"
                                title="Request Call"
                                onClick={() => this.onSubmit()}
                                disabled
                            />
                        }
                    </div>
                </div>
            </body>
        );
    }
}

export default Userinfo;